import { useLocation, useNavigate } from "react-router-dom";
import AppHeader from "./AppHeader.jsx";
import { useAuth } from "../context/AuthContext.jsx";
import { performSignOut } from "../lib/authSession.js";
import { coachNavItems } from "../lib/appNav.js";

const navItems = coachNavItems;

export default function AccountLayout({ children }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { user, clearSession } = useAuth();
  const activeItem = navItems.find((item) => item.to === pathname);
  const pageTitle = activeItem?.label ?? "Account";

  async function handleSignOut() {
    await performSignOut({ clearSession, navigate });
  }

  return (
    <div className="hc-page-shell relative min-h-screen w-full overflow-x-hidden font-sans text-hc-text">
      <div
        className="pointer-events-none absolute right-[15%] top-24 size-[320px] rounded-full bg-hc-warm/10 blur-[64px]"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute bottom-[20%] left-[10%] size-[288px] rounded-full bg-hc-cool/15 blur-[64px]"
        aria-hidden
      />

      <AppHeader navItems={navItems} onSignOut={handleSignOut} />

      <div className="relative z-10 mx-auto max-w-6xl px-6 pb-16 pt-10">
        <div className="mb-8">
          <h1 className="text-3xl font-extrabold tracking-[0.4px] text-hc-text">
            {pageTitle}
          </h1>
          <p className="mt-1 text-sm tracking-[-0.15px] text-hc-text-dim">
            {user?.email ?? "\u00a0"}
          </p>
        </div>

        <div className="space-y-5">{children}</div>
      </div>
    </div>
  );
}
